import { useAuth } from "./AuthProvider";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "../components/Spinner";

/**
 * Route guard: requires an authenticated session. Unauthenticated users are
 * directed to the custom login with their local destination retained.
 */
export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();
  if (auth.status === "loading" || (auth.status === "signedIn" && auth.busy)) {
    return (
      <div className="centered-screen">
        <Spinner label={auth.status === "loading" ? "Loading your session…" : "Signing you out…"} />
      </div>
    );
  }

  if (auth.status !== "signedIn") {
    return <Navigate to="/login" replace state={{ returnTo: location.pathname + location.search + location.hash }} />;
  }

  return <Outlet />;
}
